export const snacksCategories = [
  {
    id: "cat-10",
    name: "Snacks",
    handle: "snacks",
    description: null,
    image_url: null,
    sort_order: 1,
  },
  {
    id: "cat-11",
    name: "Sweets & Desserts",
    handle: "sweets-desserts",
    description: null,
    image_url: null,
    sort_order: 2,
  },
  {
    id: "cat-12",
    name: "Noodles",
    handle: "noodles",
    description: null,
    image_url: null,
    sort_order: 3,
  },
  {
    id: "cat-13",
    name: "Condiments",
    handle: "condiments",
    description: null,
    image_url: null,
    sort_order: 4,
  },
  {
    id: "cat-14",
    name: "Beverages",
    handle: "beverages",
    description: null,
    image_url: null,
    sort_order: 5,
  },
  {
    id: "cat-15",
    name: "Miscellaneous",
    handle: "miscellaneous",
    description: null,
    image_url: null,
    sort_order: 6,
  },
];

export const snacksRawProducts = [
  {
    region: "MARUKA-SHOKUHIN CO.,LTD",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "IKATEN SETOUCHI LEMON, SQUID TEMPURA SNACK (SQUID CHIPS)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override:
      "/assets/images/snacks/IKATEN SETOUCHI LEMON, SQUID TEMPURA SNACK (SQUID CHIPS).png",
  },
  {
    region: "MARUKA-SHOKUHIN CO.,LTD",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "GOMA ABURA KAORU SAKUSAKU KANNKOKUHU NORITEN (SEAWEED CHIPS)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override:
      "/assets/images/snacks/GOMA ABURA KAORU SAKUSAKU KANNKOKUHU NORITEN (SEAWEED CHIPS).png",
  },
  {
    region: "MARUKA-SHOKUHIN CO.,LTD",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "NORITEN SETOUCHI SUDACHI FLAVOR (SEAWEED CHIPS)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/NORITEN SETOUCHI SUDACHI FLAVOR (SEAWEED CHIPS).png",
  },
  {
    region: "MARUKA-SHOKUHIN CO.,LTD",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "KISHUUME TO AKASHISO KAORU SAKUSAKU NORITEN (SEAWEED CHIPS)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override:
      "/assets/images/snacks/KISHUUME TO AKASHISO KAORU SAKUSAKU NORITEN (SEAWEED CHIPS).png",
  },
  {
    region: "TENTAKAKU Co., Ltd.",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "HALAL&VEGAN JAPANESE STYLE VEGETABLE SOUP RAMEN",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/HALAL&VEGAN JAPANESE STYLE VEGETABLE SOUP RAMEN.png",
  },
  {
    region: "TENTAKAKU Co., Ltd.",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "HALAL&VEGAN TOYAMA BLACK SOY-SAUCE RAMEN",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/HALAL&VEGAN TOYAMA BLACK SOY-SAUCE RAMEN.png",
  },
  {
    region: "Ichiyama Co., Ltd.",
    type: "Conventional",
    category: "Teaware",
    tea_type: "Other",
    name: "SAKURA MINI MATCHA BOWL & TEA WHISK SET",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/s-ichiyama_com.jpg",
  },
  {
    region: "Ichiyama Co., Ltd.",
    type: "Conventional",
    category: "Teaware",
    tea_type: "Other",
    name: "CRIMSON LOTUS MATCHA BOWL & TEA WHISK SET",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/s-ichiyama_com.jpg",
  },
  {
    region: "Ichiyama Co., Ltd.",
    type: "Conventional",
    category: "Teaware",
    tea_type: "Other",
    name: "ARITA WARE BLUE INK SAKURA TEAPOT SET",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/s-ichiyama_com.jpg",
  },
  {
    region: "Yamadera",
    type: "Conventional",
    category: "Teaware",
    tea_type: "Other",
    name: "HIMETSUCHI HAGI WARE",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/HIMETSUCHI HAGI WARE (TEAWARE).png.jpeg",
  },
  {
    region: "Yamadera",
    type: "Conventional",
    category: "Teaware",
    tea_type: "Other",
    name: "HAGIMURASAKI HAGI WARE",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/HAGIMURASAKI HAGI WARE（TEAWARE）.png",
  },
  {
    region: "IKIGAI Ritual Co., Ltd.",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "BENI BITES DATES (DRIED SWEET POTATO)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/beni_bites_dates_list.jpg",
    detail_image: "/assets/images/snacks/beni_bites_dates_detail.jpg",
  },
  {
    region: "IKIGAI Ritual Co., Ltd.",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "BENI BITES DATES CRUNCH (DRIED SWEET POTATO)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/BENI BITES DATES CRUNCH (DRIED SWEET POTATO).webp",
  },
  {
    region: "IKIGAI Ritual Co., Ltd.",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "BENI BITES PROTEIN (DRIED SWEET POTATO)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/BENI BITES PROTEIN (DRIED SWEET POTATO).webp",
  },
  {
    region: "Seiki Co., Ltd.",
    type: "Conventional",
    category: "Sweets & Desserts",
    tea_type: "Other",
    name: "MATCHA MOCHI",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/MATCHA MOCHI.jpg",
  },
  {
    region: "Seiki Co., Ltd.",
    type: "Conventional",
    category: "Sweets & Desserts",
    tea_type: "Other",
    name: "YUZU MOCHI",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/YUZU MOCHI.jpg",
  },
  {
    region: "Pole Star Co., Ltd.",
    type: "Conventional",
    category: "Condiments",
    tea_type: "Other",
    name: "GARLIC STEAK SAUCE",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/GARLIC STEAK SAUCE.png",
  },
  {
    region: "SANIKU FOODS CO., LTD.",
    type: "Conventional",
    category: "Condiments",
    tea_type: "Other",
    name: "BLACK SESAME CREAM",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/BLACK SESAME CREAM.webp",
  },
  {
    region: "SAKAE SHOYU BREWERY Co., Ltd.",
    type: "Conventional",
    category: "Condiments",
    tea_type: "Other",
    name: "SOY SAUCE",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/sakaeshoyu_co_jp.jpg",
  },
  {
    region: "RARAYA Co., Ltd.",
    type: "Conventional",
    category: "Miscellaneous",
    tea_type: "Other",
    name: "RANDOSERU",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/randoseru_list.jpg",
    detail_image: "/assets/images/snacks/randoseru_detail.jpg",
  },
  {
    region: "YAMAEI Co.,Ltd.",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "ORGANIC JAPANESE MATCHA POWDER  (LATTE GRADE)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/ORGANIC JAPANESE MATCHA POWDER  (LATTE GRADE).jpg",
  },
  {
    region: "YAMAEI Co.,Ltd.",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "ORGANIC YAMAEI COLD BREW BROWN RICE TEA  (TEA BAG)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/ORGANIC YAMAEI COLD BREW BROWN RICE TEA  (TEA BAG).jpg",
  },
  {
    region: "YAMAEI Co.,Ltd.",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "ORGANIC YAMAEI COLD BREW ROASTED GREEN TEA  (TEA BAG)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override:
      "/assets/images/snacks/ORGANIC YAMAEI COLD BREW ROASTED GREEN TEA  (TEA BAG).jpg",
  },
  {
    region: "YAMAEI Co.,Ltd.",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "ORGANIC LEMON GREEN TEA  (TEA BAG)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/ORGANIC LEMON GREEN TEA  (TEA BAG).jpg",
  },
  {
    region: "NAKAYAMA KICHISHOEN Co., Ltd.",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "RICH YAME MATCHA LATTE POWDER",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/RICH YAME MATCHA LATTE POWDER.jpg",
  },
  {
    region: "NAKAYAMA KICHISHOEN Co., Ltd.",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "RICH HOJICHA LATTE",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/RICH HOJICHA LATTE.jpg",
  },
  {
    region: "Wakashou Co., Ltd.",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "CHIA SEED KONJAC JELLY",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/CHIA SEED KONJAC JELLY.jpg",
  },
  {
    region: "GINBIS CO., LTD.",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "SHIMI CHOCO CORN WITH WHOLE WHEAT FLOUR (CHOCOLATE SNACK)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/shimi_choco_corn_list.png",
    detail_image: "/assets/images/snacks/shimi_choco_corn_detail.png",
  },
  {
    region: "GINBIS CO., LTD.",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "ASPARAGUS BISCUITS 135G",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/ASPARAGUS BISCUITS 135G.png",
  },
  {
    region: "Ono Farm",
    type: "Conventional",
    category: "Sweets & Desserts",
    tea_type: "Other",
    name: "GELATO",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/GELATO.jpg",
  },
  {
    region: "Misohan Co., Ltd.",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "DELICIOUS SALT NYUUMEN (SOMEN NOODLES IN SOUP)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/DELICIOUS SALT NYUUMEN (SOMEN NOODLES IN SOUP).jpg",
  },
  {
    region: "Misohan Co., Ltd.",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "VEGETABLE SOUP STOCK NYUUMEN (SOMEN NOODLES IN SOUP)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override:
      "/assets/images/snacks/VEGETABLE SOUP STOCK NYUUMEN (SOMEN NOODLES IN SOUP).jpg",
  },
  {
    region: "Misohan Co., Ltd.",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "JAPANESE STYLE CURRY NYUUMEN (SOMEN NOODLES IN SOUP)",
    p2025: null,
    p2026: null,
    notes: null,
    image_override:
      "/assets/images/snacks/JAPANESE STYLE CURRY NYUUMEN (SOMEN NOODLES IN SOUP).jpg",
  },
  {
    region: "Morinaga Gyunyu Haikyu Co.,Ltd.",
    type: "Conventional",
    category: "Sweets & Desserts",
    tea_type: "Other",
    name: "DANGO",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/morinaga-gh_co_jp.jpg",
  },
  {
    region: "Marin food Co., Ltd.",
    type: "Conventional",
    category: "Sweets & Desserts",
    tea_type: "Other",
    name: "FROZEN BRULEE CREPE",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/snats-foods_com.png",
  },
  {
    region: "Hokkaido Kaihatsu Group Co., Ltd.",
    type: "Conventional",
    category: "Snacks",
    tea_type: "Other",
    name: "SHIROI KOIBITO（CHOCOLATE SNACK）",
    p2025: null,
    p2026: null,
    notes: null,
    image_override: "/assets/images/snacks/hdgroup_jp.jpg",
  },
  {
    region: "YAMADAI Corporation",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "VEGAN NOODLE TAN TAN MEN",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/VEGAN NOODLE TAN TAN MEN.jpg",
  },
  {
    region: "YAMADAI Corporation",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "VEGAN NOODLE HOT AND SOUR SOUP",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/VEGAN NOODLE HOT AND SOUR SOUP.jpg",
  },
  {
    region: "YAMADAI Corporation",
    type: "Conventional",
    category: "Noodles",
    tea_type: "Other",
    name: "VEGAN NOODLE SOY SAUCE",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/VEGAN NOODLE SOY SAUCE.jpg",
  },
  {
    region: "Seika Foods Co.,Ltd.",
    type: "Conventional",
    category: "Sweets & Desserts",
    tea_type: "Other",
    name: "MOMO MOCHI (SOFT CANDY MADE FROM MOCHI)",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/MOMO MOCHI (SOFT CANDY MADE FROM MOCHI).png",
  },
  {
    region: "Seika Foods Co.,Ltd.",
    type: "Conventional",
    category: "Sweets & Desserts",
    tea_type: "Other",
    name: "BONTAN AME (SOFT CANDY MADE FROM MOCHI)",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/seikafoods_jp.png",
  },
  {
    region: "ASEED BEVERAGE PLUS CO.,LTD",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "ENERGY BOMBER",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/ENERGY BOMBER.jpg",
  },
  {
    region: "ASEED BEVERAGE PLUS CO.,LTD",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "PARADE MILK COFFEE",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/PARADE MILK COFFEE.jpg",
  },
  {
    region: "ASEED BEVERAGE PLUS CO.,LTD",
    type: "Conventional",
    category: "Beverages",
    tea_type: "Other",
    name: "PARADE MILK SHAKE",
    p2025: null,
    p2026: null,
    notes: "Minimum 10 cases",
    image_override: "/assets/images/snacks/PARADE MILK SHAKE.jpg",
  },
];

export const snacksSeed = snacksRawProducts.map((p, index) => {
  const handle = p.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
  const cat = snacksCategories.find((c) => c.name === p.category) || {
    id: "cat-unknown",
    name: "Unknown",
  };

  return {
    id: `snack-prod-${index + 1}`,
    name: p.name.trim(),
    handle: handle,
    category_id: cat.id,
    categories: { name: cat.name, handle: cat.name.toLowerCase().replace(/\s+/g, "-") },
    active: true,
    description: (p as any).description || null,
    short_description: null,
    image_url: p.image_override || "/assets/images/placeholder.jpg",
    detail_image_url: (p as any).detail_image || null,
    sort_order: index + 1,
    specs: {
      region: p.region,
      type: p.type,
      tea_type: p.tea_type,
    },
    created_at: new Date().toISOString(),
  };
});
